import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';

import { useChatConfig } from '@/contexts/ChatConfigProvider';
import { useRouter } from '@/hooks/useRouter.js';
import { useUser } from '@/hooks/useUser.js';
import { aiCoreApi } from '@/services/aiCoreClient';

import { Loader } from '../../components/loader/Loader.js';

/**
 * This route is empty with a loader, it is displayed after the widget is opened.
 * This allows us to authenticate a user before displaying the chat which makes
 * things much easier, since we don't have to handle situations in Chat
 * where user doesn't exist yet.
 */
export function InitialRoute() {
  const { chatId } = useChatConfig();
  const { pushRoute } = useRouter();
  const { login, user } = useUser();

  /**
   * Authenticate users against API, this will create a new user
   * in the database if it does not exist. Otherwise, it will return
   * the existing user.
   */
  const { mutateAsync: authenticate } = useMutation({
    mutationFn: async () => {
      const data = await aiCoreApi.auth.local({
        chatId,
      });

      login(data.user, data.token);
      pushRoute('chat');
    },
  });

  // Quickly authenticate user autonomously
  useEffect(() => {
    if (user) {
      return;
    }

    authenticate();
  }, [authenticate, pushRoute, user]);

  return <Loader />;
}
